import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { AppState } from '../../../types/store';
import { setCompliantLocalStorageItem } from '@wix/da-shared-react/pkg/redux/compliantLocalStorage/actions';
import {
  screenLoaded,
  toggleIntent,
  toggleOther,
  clickOtherDone,
  clickOtherCancel,
  clickSkip,
  clickContinue,
} from '../../../actions/bi/intent.bi';
import { Props } from './IntentsPage';

type StateProps = Pick<Props, 'authMode' | 'referer'>;
type DispatchProps = Pick<
  Props,
  | 'screenLoaded'
  | 'toggleIntent'
  | 'toggleOther'
  | 'clickOtherDone'
  | 'clickOtherCancel'
  | 'clickSkip'
  | 'clickContinue'
  | 'setCompliantLocalStorageItem'
>;
type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  authMode: state.authMode,
  referer: state.referer,
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  screenLoaded,
  toggleIntent,
  toggleOther,
  clickOtherDone,
  clickOtherCancel,
  clickSkip,
  clickContinue,
  setCompliantLocalStorageItem,
};

export default connect(mapStateToProps, mapDispatchToProps);
